import { render, staticRenderFns } from "./ArticleReview.vue?vue&type=template&id=52b2d440&scoped=true&"
import script from "./ArticleReview.vue?vue&type=script&lang=js&"
export * from "./ArticleReview.vue?vue&type=script&lang=js&"
import style0 from "./ArticleReview.vue?vue&type=style&index=0&id=52b2d440&prod&lang=css&"
import style1 from "./ArticleReview.vue?vue&type=style&index=1&id=52b2d440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b2d440",
  null
  
)

export default component.exports